import { render, staticRenderFns } from "./FileMenuEdit.vue?vue&type=template&id=07144b5c&scoped=true&"
import script from "./FileMenuEdit.vue?vue&type=script&lang=js&"
export * from "./FileMenuEdit.vue?vue&type=script&lang=js&"
import style0 from "./FileMenuEdit.vue?vue&type=style&index=0&id=07144b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07144b5c",
  null
  
)

export default component.exports